mutation RepublishMerchBoards($shop: String!) {
  result: StreamToolsRepublishMerchBoards(shop: $shop) {
    shop
    version
    boardsPublished
    extensionAttempted
  }
}
